import { defineStore } from 'pinia';
import LeadsAPI from 'dashboard/api/leads';
import LeadFollowUpsAPI from 'dashboard/api/leadFollowUps';

export const useLeadsStore = defineStore('leads', {
  state: () => ({
    listByPipeline: {}, // { pipelineId: [leads] }
    current: null,
    meta: {},
    loading: false,
    isImporting: false,
  }),
  actions: {
    async fetch(params = {}) {
      this.loading = true;
      try {
        const { data } = await LeadsAPI.index(params);
        if (params.pipeline_id) {
          this.listByPipeline = {
            ...this.listByPipeline,
            [params.pipeline_id]: data.leads,
          };
        }
        this.meta = data.meta || {};
        return data;
      } finally {
        this.loading = false;
      }
    },
    async fetchOne(id) {
      const { data } = await LeadsAPI.show(id);
      this.current = data;
      return data;
    },
    async create(payload) {
      const { data } = await LeadsAPI.create({ lead: payload });
      return data;
    },
    async update(id, payload) {
      const { data } = await LeadsAPI.update(id, { lead: payload });
      if (this.current?.id === id) this.current = data;
      return data;
    },
    async qualify(id, payload) {
      const { data } = await LeadsAPI.qualify(id, payload);
      return data;
    },
    async moveStage(id, stageId, reason) {
      const { data } = await LeadsAPI.moveStage(id, {
        stage_id: stageId,
        reason,
      });
      return data;
    },
    async changePipeline(id, pipelineId, reason) {
      const { data } = await LeadsAPI.changePipeline(id, {
        pipeline_id: pipelineId,
        reason,
      });
      return data;
    },
    async win(id, payload) {
      const { data } = await LeadsAPI.win(id, payload);
      return data;
    },
    async lose(id, payload) {
      const { data } = await LeadsAPI.lose(id, payload);
      return data;
    },
    async reopen(id, reason) {
      const { data } = await LeadsAPI.reopen(id, { reason });
      return data;
    },
    async discard(id, reason) {
      const { data } = await LeadsAPI.discard(id, { reason });
      return data;
    },
    async generateSummary(id) {
      const { data } = await LeadsAPI.generateSummary(id);
      return data.summary;
    },
    async applyFollowUp(leadId, templateId, reason) {
      const { data } = await LeadFollowUpsAPI.apply(leadId, {
        template_id: templateId,
        reason,
      });
      return data;
    },
    async switchFollowUp(leadId, followUpId, templateId, reason) {
      const { data } = await LeadFollowUpsAPI.switch(leadId, followUpId, {
        template_id: templateId,
        reason,
      });
      return data;
    },
    async import(file) {
      this.isImporting = true;
      try {
        const { data } = await LeadsAPI.importLeads(file);
        return data;
      } finally {
        this.isImporting = false;
      }
    },
  },
});
